import React, { createContext, useContext, useState } from 'react';
import { login as apiLogin, mfaVerify as apiMfaVerify } from '../services/api';

const AuthContext = createContext(null);

// Session ouverte avant DO-208 : pas de rôle stocké, on le lit dans le JWT (claim « role »).
// Purement cosmétique (menus) : le back applique les rôles lui-même.
function roleFromToken(token) {
  try {
    const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(payload)).role || null;
  } catch {
    return null;
  }
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const token = localStorage.getItem('token');
    const username = localStorage.getItem('username');
    const role = localStorage.getItem('role') || (token && roleFromToken(token));
    return token ? { token, username, role } : null;
  });

  const openSession = data => {
    localStorage.setItem('token', data.token);
    localStorage.setItem('username', data.username);
    localStorage.setItem('role', data.role);
    setUser({ token: data.token, username: data.username, role: data.role });
  };

  // MFA (DO-207) : sans token dans la réponse, une seconde étape est demandée
  // (mfaRequired / mfaSetupRequired + mfaToken), terminée par verifyMfa.
  const login = async (username, password) => {
    const data = await apiLogin(username, password);
    if (data.token) openSession(data);
    return data;
  };

  const verifyMfa = async (mfaToken, code, trustBrowser) => {
    const data = await apiMfaVerify(mfaToken, code, trustBrowser);
    openSession(data);
    return data;
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    localStorage.removeItem('role');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, verifyMfa, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
